import template from './dashboard.html';

const dashboardComponent = {
  restrict: 'E',
  bindings: {},
  template
};

export default dashboardComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/dashboard/dashboard.component.js
 **/